import { create, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { SlidingPane } from '@holmescorp/base-widgets/sliding-pane';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { subscribe } from 'pub-sub';
import { createNlsMiddleware, lccstate, registry } from 'lcc-state';
import { delay } from '@holmescorp/common';
import { viewport } from '../support/viewport';

interface CertPaneIcache {
	open: boolean;
	aboutToOpen: boolean;
}

export interface CertPaneProperties {
	onClose?: () => void;
}

const icache = createICacheMiddleware<CertPaneIcache>();
const nls = createNlsMiddleware('settings');
const factory = create({
	icache,
	theme,
	nls,
	lccstate
}).properties<CertPaneProperties>();

export const CertPane = factory(({ properties, middleware: { icache, nls } }) => {
	const { onClose } = properties();
	icache.getOrSet('aboutToOpen', false);
	const open = icache.getOrSet('open', () => {
		subscribe('cert/open', async () => {
			icache.set('aboutToOpen', true);
			await delay(200);
			icache.set('open', true);
		});
		subscribe('close-all/panes', () => {
			icache.set('open', false);
		});
		return false;
	});

	const { vw } = viewport();
	const {
		messages: { certificate_title = '[settings] certificate_title' }
	} = nls();
	const key = `cert-pane`;
	const xqa = `cert-pane-${open}`;

	return w(
		SlidingPane,
		{
			xqa,
			key,
			open,
			align: 'right',
			underlay: true,
			title: certificate_title,
			width: Math.min(vw, 1024),
			onRequestClose: () => {
				icache.set('open', false);
				icache.set('aboutToOpen', async () => {
					await delay(500);
					return true;
				});
				onClose && onClose();
			}
		},
		[w('Certificate', {})]
	);
});

registry.define('CertPane', CertPane);
